/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useState } from 'react';

import {
	Button,
	Grid,
	Typography,
	Select,
	MenuItem,
	Modal,
	FormControl,
	TextField,
	Snackbar,
	InputLabel,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Scheduler } from '@aldabil/react-scheduler';
import Box from '@mui/material/Box';
import WebLogo from '../../../../assets/logos/websitelogo.svg';

import {
	ClockIcon,
	DatePicker,
	DateTimePicker,
	LocalizationProvider,
} from '@mui/x-date-pickers';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { Menu } from '@mui/joy';
import { useStateValue } from '../../../services/state/State';
import {
	addAppointment,
	getAppointment,
	getLocation,
	getPatientList,
	getPracticeStaff,
	updateAppointment,
} from '../../../services/api/apiManager';
import { Cancel, Circle, MoreVert, Refresh } from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
const style = {
	position: 'absolute',
	top: '38%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: 'white',
	fontFamily: 'Poppins',
	borderRadius: '5px',
	width: '70%',
};

function Schedular(props) {
	const [loading, setLoading] = useState(false);
	const practiceId = localStorage.getItem('practice_id');
	const [{ locations, practice }] = useStateValue();
	const [patientList, setPatientList] = useState([]);
	const [location, setLocation] = useState([]);
	const [providerList, setProviderList] = useState([]);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [updateReason, setUpdateReason] = useState('');
	const [updateProvider, setUpdateProvider] = useState('');
	const [updateLocation, setUpdateLocation] = useState('');
	const [udatePatientName, setUpdatePatientName] = useState('');
	const [updateAppointmentStatus, setUpdateAppointmentStatus] = useState('P');
	const [appointmentID, setAppointmentID] = useState(0);
	const [invalidInfo, setInvalidInfo] = useState(false);
	const [updateAppointmentData, setUpdateAppointmentData] = useState({
		patient_id: 130,
		provider_id: 9,
		location_id: 5,
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm'),
		Status: 'P',
		Reason: 'Right Fight',
	});
	const [provider, setProvider] = React.useState('');
	const [staffList, setStaffList] = useState([]);
	const [filterLocation, setFilterLocation] = React.useState('');
	const [selectedFilterDate, setSelectedFilterDate] = useState(null);
	const [appointmentList, setAppointmentList] = useState([]);

	const [filteredAppointments, setFilteredAppointments] = useState([]);

	const handleProvider = (event) => {
		const selectedProvider = event.target.value;
		setProvider(selectedProvider);

		const filterAppointmentss = selectedProvider
			? appointmentList?.filter((appointment) => {
					if (filterLocation === '') {
						return appointment.provider_id === parseInt(selectedProvider);
					} else if (filterLocation !== '') {
						return (
							appointment.provider_id === parseInt(selectedProvider) &&
							appointment.location_id === parseInt(filterLocation)
						);
					}
				})
			: appointmentList;
		setFilteredAppointments(filterAppointmentss);
	};
	const handleFilterLocation = (e) => {
		setFilterLocation(e.target.value);
		const filterAppointmentss = e.target.value
			? appointmentList?.filter((appointment) => {
					if (provider === '') {
						return appointment?.location_id === parseInt(e.target.value);
					} else if (provider !== '') {
						return (
							appointment?.location_id === parseInt(e.target.value) &&
							appointment?.provider_id === parseInt(provider)
						);
					}
				})
			: appointmentList;
		setFilteredAppointments(filterAppointmentss);
	};
	const handleDateChange = (date) => {
		const dataSelect = date;
		setSelectedFilterDate(dataSelect);
		const filterAppointments = dataSelect
			? appointmentList?.filter((appointment) => {
					const formattedAppointmentDate = new Date(appointment?.start)
						.toISOString()
						.split('T')[0];

					return formattedAppointmentDate === dataSelect?.format('YYYY-MM-DD');
				})
			: appointmentList;

		setFilteredAppointments(filterAppointments);
	};
	const fetchAppointments = async () => {
		setLoading(true);
		const res = await getAppointment();
		if (res?.status === 200) {
			const appointmentsAccording_toLibrary_format = res?.data
				?.filter((items) => items?.patient?.practice_id == practiceId)
				.map((items) => {
					return {
						locationName: items?.location?.Name,
						event_id: items?.id,
						title:
							items?.Reason == ''
								? 'Reason Not Written'
								: items?.Reason === null
									? 'Reason Not Mention'
									: items?.Reason,
						start: new Date(items?.AppointmentDate),
						end: new Date(
							new Date(items?.AppointmentDate)?.setTime(
								new Date(items?.AppointmentDate)?.getTime() + 30 * 60 * 1000
							)
						),
						admin_id: items?.id,
						patientFullName:
							items?.patient?.Fname + ' ' + items?.patient?.Lname,
						patient_id: items?.patient_id,
						provider_id: items?.provider_id,
						Status: items?.Status,
						location_id: items?.location_id,
						color:
							items?.Status === 'C'
								? 'green'
								: items?.Status === 'D'
									? 'red'
									: items?.Status === 'O'
										? 'grey'
										: 'yellow',
						textColor:
							items?.Status === 'C'
								? 'White'
								: items?.Status === 'D'
									? 'Wheat'
									: 'Black',
						editable: false,
						deletable: false,
						draggable: false,
					};
				});
			setAppointmentList(appointmentsAccording_toLibrary_format);
			setFilteredAppointments(appointmentsAccording_toLibrary_format);
			setLoading(false);
		} else if (res?.status === undefined) {
			setAppointmentList([]);
			setFilteredAppointments([]);
		}
	};
	// add appointment start
	const [openAdd, setOpenAdd] = React.useState(false);
	const [appointment, setappoitment] = useState({
		// practice_id: practice_id,
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
		Status: '',
		Reason: '',
	});
	const handleOpenAddAppointment = () => setOpenAdd(true);
	const handleCloseModal = () => {
		setappoitment({
			patient_id: '',
			provider_id: '',
			AppointmentDate: dayjs(selectedDate),
			location_id: '',
			Status: 'P',
			Reason: '',
		});
		setOpenAdd(false);
	};
	// for adding new appointments
	const addNewAppointment = async (data) => {
		const resp = await addAppointment(data);
		if (resp.status === 201) {
			setPostSucessfully(true);
			setOpenSnackbar(true);
			handleCloseModal();
			setappoitment({
				patient_id: '',
				provider_id: '',
				AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
				Status: 'P',
				location_id: '',
				Reason: '',
			});
			fetchAppointments();
			setselectedDate(dayjs(new Date()));
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	// add appointment end
	const handleReset = () => {
		setProvider('');
		setFilterLocation('');
		setSelectedFilterDate(null);
		setFilteredAppointments(appointmentList);
	};
	const fetchPracticeStaff = async () => {
		debugger;
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};
	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row?.Fname + ' ' + row?.Lname,
			providerId: row?.id,
		}));
	const [open, setOpen] = React.useState(false);

	// from this function modal is opening and selected events values of schedular are setting
	const Add = (event) => {
		setUpdateAppointmentData({
			patient_id: event?.patient_id,
			provider_id: event?.provider_id,
			location_id: event?.location_id,
			AppointmentDate: dayjs(event?.start).format('YYYY-MM-DDTHH:mm:ss'),
			Status: event?.Status,
			Reason: event?.title,
		});
		// when modal opening all values will be according to patient appointment
		setUpdatePatientName(event?.patient_id);
		setUpdateAppointmentStatus(event?.Status);
		setUpdateProvider(event?.provider_id);
		setUpdateLocation(event?.location_id);
		setUpdateReason(event?.title);
		setselectedDate(dayjs(event?.start));
		setAppointmentID(event?.event_id);
		setOpen(true);
	};
	const handleClose = () => setOpen(false);

	const handleCloseSnackbar = () => setOpenSnackbar(false);

	// Modal Delete with these state values are shown in delete Modal
	const [openDeleteModal, setOpenDeleteModal] = useState({
		deleteModalOpen: false,
		deletingId: '',
		deletingName: '',
		deletingReason: '',
	});
	const handleOpenDeleteModal = (data) => {
		setOpenDeleteModal({
			deleteModalOpen: true,
			deletingId: data?.event_id,
			deletingName: data?.patientFullName,
			deletingReason: data?.Reason,
		});
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal({
			deleteModalOpen: false,
			deletingId: '',
			deletingName: '',
			deletingReason: '',
		});
	};

	const fetchPatientList = async (id) => {
		const resp = await getPatientList(id);
		if (resp?.status === 200) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	const fetchProviderList = async () => {
		debugger;
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setProviderList(res?.data);
		} else {
			setProviderList([]);
		}
	};

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocation(resp?.data);
		}
	};

	const updateAppointmentInfo = async (id, data) => {
		const resp = await updateAppointment(id, data);
		if (resp?.status === 200) {
			setPostSucessfully(true);
			setOpen(false);
			fetchAppointments();
			props.updatingSnackbar(true);
			if (resp?.data.Deleted === true) {
				handleCloseDeleteModal();
				props.deletingAppointment(true);
			}

			setOpenSnackbar(true);
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};

	useEffect(() => {
		fetchPracticeStaff();
		fetchPatientList(practiceId);
		getLocationsData();
		fetchProviderList();
		fetchAppointments();
	}, []);
	useEffect(() => {
		fetchAppointments();
	}, [props?.reRenderFromParent]);
	return (
		<Fragment>
			{/* {<h2>{props.reRenderFromParent?.toString()}</h2>} */}
			<Grid container item xs={12} lg={12} xl={12} md={12} sm={12}>
				<Grid
					container
					item
					sx={{
						padding: '8px',
						background: 'white',
						border: '1px solid #CFCACA',
						// display: 'flex',
						// alignItems: 'center',
					}}
				>
					<Grid
						item
						xs={6}
						sm={3}
						md={3}
						xl={3}
						lg={3}
						sx={{ padding: '8px 4px 4px 4px' }}
					>
						<Box>
							<FormControl htmlFor="providerFilterID" size="small" fullWidth>
								<InputLabel
									id="providerFilterID"
									sx={{
										fontSize: '15px',
									}}
								>
									Provider
								</InputLabel>
								<Select
									defaultValue=""
									name="providerFilter"
									value={provider}
									onChange={handleProvider}
									label="Provider"
									inputProps={{ 'aria-label': 'Without label' }}
									sx={{
										borderLeft: '5px solid #DA8541',
										borderRadius: '4px',
										'&.MuiInput-underline:before': {
											borderBottom: 'none',
										},
										'&.Mui-focused': {
											'&.MuiInput-underline:before': {
												borderBottom: 'none',
											},
										},
										'& .MuiOutlinedInput-notchedOutline': {
											boxShadow: '-5px 0px #FD7702',
										},
									}}
									MenuProps={{
										PaperProps: {
											style: {
												width: '7.3%',
												height: '18%',
												overflowY: 'scroll',
												overflowX: 'scroll',
											},
										},
									}}
								>
									<MenuItem value="">Clear Filter</MenuItem>
									{mappingProviderList &&
										mappingProviderList.length > 0 &&
										mappingProviderList.map((pl, index) => (
											<MenuItem key={index} value={pl.providerId}>
												{pl?.name}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid
						item
						xs={6}
						sm={3}
						md={3}
						xl={3}
						lg={3}
						sx={{ padding: '8px 4px 4px 4px' }}
					>
						<Box>
							<FormControl
								size="small"
								fullWidth
								inputProps={{ 'aria-label': 'Without label' }}
							>
								<InputLabel
									id="locationFilterID"
									sx={{
										fontSize: '15px',
									}}
								>
									Location
								</InputLabel>
								<Select
									defaultValue=""
									name="locationFilterID"
									label="Provider"
									inputProps={{ 'aria-label': 'Without label' }}
									MenuProps={{
										PaperProps: {
											style: {
												width: '7.3%',
												height: '18%',
												overflowY: 'scroll',
												overflowX: 'scroll',
											},
										},
									}}
									value={filterLocation}
									onChange={handleFilterLocation}
									sx={{
										borderLeft: '5px solid #DA8541',
										borderRadius: '4px',
										// height: '50px',

										'&.MuiInput-underline:before': {
											borderBottom: 'none',
										},
										'&.Mui-focused': {
											'&.MuiInput-underline:before': {
												borderBottom: 'none',
											},
										},
										'& .MuiOutlinedInput-notchedOutline': {
											boxShadow: '-5px 0px #FD7702',
										},
									}}
								>
									<MenuItem value="">Clear Filter</MenuItem>
									{location?.map((items, index) => {
										return (
											<MenuItem key={index} value={items?.id}>
												{items?.Name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid
						item
						xs={6}
						sm={4}
						md={5}
						xl={4}
						lg={4}
						sx={{ paddingLeft: '4px' }}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DatePicker']}>
									<DemoItem>
										{/* <DatePicker
														label="Date"
														size="small"
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															width: '100%',
														}}
														slotProps={{ textField: { size: 'small' } }}
														value={selectedFilterDate}
														onChange={handleDateChange}
													/> */}

										<DatePicker
											label="Date"
											sx={{
												borderLeft: '6px solid #DA8541',
												borderRadius: '7px',
												width: '100%',
												'.css-4jnixx-MuiStack-root': {
													paddingTop: '0px',
												},
											}}
											slotProps={{ textField: { size: 'small' } }}
											value={selectedFilterDate}
											onChange={handleDateChange}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
							<Button
								onClick={handleReset}
								variant="contained"
								size="medium"
								color="success"
								style={{}}
								sx={{
									marginLeft: '10px',
									marginTop: '8px',
									// width: {
									// 	xl: '20%',
									// 	lg: '20%',
									// 	md: '18%',
									// 	sm: '10%',
									// 	xs: '10%',
									// },
								}}
							>
								<Refresh />
							</Button>
						</Box>
					</Grid>
					<Grid
						item
						xs={6}
						sm={2}
						md={1}
						xl={2}
						lg={2}
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							alignItems: 'center',
						}}
					>
						<Button
							onClick={handleOpenAddAppointment}
							startIcon={<PersonAddIcon />}
							sx={{
								// height: '30px',
								color: 'white',

								background: '#FD7702',
								fontWeight: '500',
								fontFamily: 'Poppins',
								'&:hover': {
									border: '#FD7702',
									color: '#FD7702',
									background: 'white',
								},
							}}
						>
							Add
						</Button>
					</Grid>
				</Grid>

				<Grid
					item
					xs={12}
					lg={12}
					xl={12}
					md={12}
					sm={12}
					sx={{
						height: {
							xl: '75vh',
							lg: '70vh',
							md: '65vh',
							sm: '65vh',
							xs: '85vh',
						},
						overflow: 'auto',
						border: '0.5px solid lightgray',
					}}
				>
					{loading ? (
						<div
							style={{
								width: '100%',
								height: '80vh',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<div className="logo-container">
								<img className="logo" src={WebLogo} alt="Website Logo" />
							</div>
						</div>
					) : !loading && filteredAppointments?.length === 0 ? (
						<Box
							width={'100%'}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
							height={'50vh'}
							color={'red'}
						>
							No Appointment{' '}
						</Box>
					) : (
						<Scheduler
							disableAddEvent={true}
							editable={false}
							deletable={false}
							agenda={false}
							disableViewNavigator={true}
							resourceViewMode="default"
							day={{ navigation: false }}
							// navigation={false}
							stickyNavigation
							week={{
								startHour: 8,
								endHour: 23,
								navigation: true,
								disableGoToDay: true,
								step: 50,
							}}
							view="week"
							events={filteredAppointments}
							// for adding your own popper-dialog while clicking on any event
							customViewer={(event, closePopper) => {
								return (
									<>
										<Box
											width={'300px'}
											height={'155px'}
											borderRadius={'2px 2px 0 0'}
										>
											<Box
												borderRadius={'2px 2px 0 0'}
												bgcolor={'#0E4374'}
												width={'100%'}
												color={'white'}
												display={'flex'}
												justifyContent={'space-between'}
												alignItems={'center'}
												height={'40px'}
											>
												<span style={{ fontSize: '13px', marginLeft: '4px' }}>
													{event?.patientFullName}
												</span>
												<PopupState variant="popover" popupId="demo-popup-menu">
													{(popupState) => (
														<React.Fragment>
															<MoreVert
																variant="contained"
																{...bindTrigger(popupState)}
																fontSize="12px"
																sx={{ cursor: 'pointer' }}
															/>
															<Menu {...bindMenu(popupState)}>
																<MenuItem
																	onClick={() => {
																		Add(event);
																		popupState.close();
																		closePopper(); //this will close your appointment customViewer
																	}}
																>
																	Edit
																</MenuItem>
																<MenuItem
																	onClick={() => {
																		handleOpenDeleteModal(event);
																		closePopper();
																	}}
																>
																	Delete
																</MenuItem>
															</Menu>
														</React.Fragment>
													)}
												</PopupState>
											</Box>
											<Box
												width={'100%'}
												height={'30px'}
												display={'flex'}
												justifyContent={'space-between'}
												borderBottom={'1px solid #0E4374'}
											>
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginLeft: '2px',
													}}
												>
													Location:
												</span>
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginRight: '3px',
													}}
												>
													{event?.locationName}
												</span>
											</Box>
											<Box
												width={'100%'}
												height={'30px'}
												display={'flex'}
												borderBottom={'1px solid #0E4374'}
												justifyContent={'space-between'}
											>
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginLeft: '2px',
													}}
												>
													Reason:
												</span>
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginRight: '3px',
													}}
												>
													{event?.title}
												</span>
											</Box>
											<Box
												width={'100%'}
												height={'30px'}
												display={'flex'}
												justifyContent={'space-between'}
												borderBottom={'1px solid #0E4374'}
											>
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginLeft: '2px',
													}}
												>
													Appointment Status:
												</span>

												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														marginRight: '3px',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
													}}
												>
													<Circle
														sx={{
															border: '2px solid #0e4374',
															borderRadius: '35%',
															fontSize: '12px',
															color:
																event?.Status === 'C'
																	? 'green'
																	: event?.Status === 'D'
																		? 'red'
																		: event?.Status === 'O'
																			? 'grey'
																			: '#FFFC01',
														}}
													/>

													{event?.Status === 'C'
														? 'Confirmmed'
														: event?.Status === 'D'
															? 'Dismissed'
															: event?.Status === 'O'
																? 'Other'
																: 'Pending'}
												</span>
											</Box>
											<Box
												display={'flex'}
												width={'100%'}
												gap={2}
												justifyContent={'center'}
												alignItems={'center'}
											>
												<ClockIcon color="#0E4374" />
												<span
													style={{
														fontSize: '12px',
														fontWeight: 'bold',
														color: '#0E4374',
													}}
												>
													{dayjs(event?.start).format('DD/MM/YYYY HH:mm:ss A')}
												</span>
											</Box>
										</Box>
									</>
								);
							}}
						/>
					)}
				</Grid>
			</Grid>
			{/* add appointment modal */}
			<Modal
				open={openAdd}
				onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						bgcolor={'#0e4374'}
						height={'30px'}
						p={0}
						borderRadius={'10px 10px 0 0 '}
					>
						<Cancel
							sx={{ cursor: 'pointer', color: 'whitesmoke' }}
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(selectedDate),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
							}}
						/>
					</Box>
					{invalidInfo && (
						<Box
							display={
								appointment?.patient_id === ''
									? ''
									: appointment?.provider_id === ''
										? ''
										: appointment?.Status === ''
											? ''
											: appointment?.Reason === ''
												? ''
												: appointment?.AppointmentDate == 'Invalid Date'
													? ''
													: appointment?.location_id === ''
														? ''
														: 'none'
							}
						>
							<Alert variant="filled" severity="error">
								Please Fill all Information!
							</Alert>
						</Box>
					)}
					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						sx={{
							textAlign: 'center',
							fontWeight: '500',
							fontFamily: 'Poppins',
						}}
					>
						Add Appointment
					</Typography>
					<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
						<Grid container item xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
								<Grid
									item
									xs={12}
									lg={12}
									md={12}
									sm={12}
									xl={12}
									sx={{
										padding: ' 3px 13px',
									}}
								>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
										}}
									>
										Select Patient
									</Typography>
									<FormControl
										fullWidth
										sx={{
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									>
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '18%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											placeholder="Add Patient"
											value={appointment?.patient_id}
											onChange={(e) => {
												setappoitment((prev) => ({
													...prev,
													patient_id: e.target.value,
													provider_id: (patientList?.filter(
														(items) => items?.patient_id === e.target.value
													))[0]?.providerid,
													location_id: (patientList?.filter(
														(items) => items?.patient_id === e.target.value
													))[0]?.locationid,
												}));
											}}
										>
											<MenuItem value={''}>Patients</MenuItem>
											{patientList?.map((items, index) => (
												<MenuItem
													key={index}
													value={items?.patient_id}
													// style={{ width: '100%' }}
												>
													{items?.Name}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={11}
								lg={11}
								xl={11}
								sx={{
									padding: '8px 13px',
								}}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Reason
								</Typography>
								<TextField
									multiline
									fullWidth
									name="Reason"
									rows={3}
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
										boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
									}}
									value={appointment?.Reason}
									onChange={(e) =>
										setappoitment((prev) => ({
											...prev,
											Reason: e.target.value,
										}))
									}
								/>
							</Grid>
						</Grid>

						<Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Provider Name
								</Typography>
								<FormControl
									fullWidth
									name="providerId"
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
										boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
										'& .MuiOutlinedInput-input': {
											padding: '9px 0px 9px 6px',
										},
									}}
								>
									<Select
										defaultValue=""
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '18%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										placeholder="Select Provider Name"
										value={appointment?.provider_id}
										onChange={(e) =>
											setappoitment((prev) => ({
												...prev,
												provider_id: e.target.value,
											}))
										}
									>
										<MenuItem value={0} style={{ width: '100%' }} disabled>
											Provider
										</MenuItem>
										{mappingProviderList &&
											mappingProviderList.length > 0 &&
											mappingProviderList.map((item, index) => (
												<MenuItem
													key={index}
													value={item?.providerId}
													style={{ width: '100%' }}
												>
													{item?.name}
												</MenuItem>
											))}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Status
								</Typography>

								<FormControl fullWidth>
									<Select
										defaultValue=""
										labelId="Status"
										id="Status"
										value={appointment?.Status}
										name="Status"
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												Status: e.target.value,
											}));
										}}
										sx={{
											height: '40px',
											width: '100%',
											borderRadius: '6px',
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											'& .MuiOutlinedInput-input': {
												padding: '9px 0px 9px 6px',
											},
										}}
									>
										<MenuItem value={'C'}>Completed</MenuItem>
										<MenuItem value={'D'}>Dismissed</MenuItem>
										<MenuItem value={'O'}>Other</MenuItem>
										<MenuItem value={'P'}>Pending</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Location
								</Typography>
								<FormControl fullWidth>
									<Select
										defaultValue=""
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '15%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										labelId="modallocation"
										id="modallocation"
										value={appointment?.location_id}
										name="modallocation"
										sx={{ height: '45px', mt: 1 }}
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												location_id: e.target.value,
											}));
										}}
									>
										{location?.map((items, index) => {
											return (
												<MenuItem key={index} value={items?.id}>
													{items?.Name}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Date Time
								</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DemoContainer components={['DateTimePicker']}>
										<DemoItem>
											<DateTimePicker
												orientation="portrait"
												disablePast
												size="small"
												slotProps={{ textField: { size: 'small' } }}
												sx={{
													boxShadow: '1px 1px 10px #79ACF178 inset',
													width: '100%',
												}}
												value={selectedDate}
												onChange={(nValue) => {
													setselectedDate(nValue);
													setappoitment((prev) => ({
														...prev,
														AppointmentDate: dayjs(nValue).format(
															'YYYY-MM-DDTHH:mm:ss'
														),
													}));
												}}
											/>
										</DemoItem>
									</DemoContainer>
								</LocalizationProvider>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '5px',
							padding: '13px 8px 0px 8px',
						}}
						xs={12}
					>
						<Button
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(new Date()),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
								setselectedDate(dayjs(new Date()));
							}}
							sx={{
								mb: 1,
								background: '#ED2828',
								border: '2px solid #ED2828',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #ED2828',
									color: '#ED2828',
								},
							}}
						>
							Cancel
						</Button>

						<Button
							sx={{
								mb: 1,
								background: '#FD7702',
								border: '2px solid #e87511',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #e87511',
									color: '#e87511',
								},
							}}
							onClick={() => {
								if (
									appointment?.patient_id === '' ||
									appointment?.provider_id === '' ||
									appointment?.Status === '' ||
									appointment?.Reason === '' ||
									appointment?.AppointmentDate == 'Invalid Date' ||
									appointment?.location_id === ''
								) {
									setInvalidInfo(true);
								} else {
									addNewAppointment(appointment);
								}
							}}
						>
							Add Appointment
						</Button>
					</Grid>
				</Box>
			</Modal>
			{/*Update Modal Code is Starts From here */}
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						bgcolor={'#0e4374'}
						height={'30px'}
						// borderRadius={'0px 0px 0 0 '}
					>
						<Cancel
							sx={{ cursor: 'pointer', color: 'whitesmoke' }}
							onClick={() => {
								setOpen(false);
							}}
						/>
					</Box>
					{
						<Box
							display={
								updateAppointmentData?.patient_id === ''
									? ''
									: updateAppointmentData?.provider_id === ''
										? ''
										: updateAppointmentData?.Status === ''
											? ''
											: updateAppointmentData?.Reason === ''
												? ''
												: updateAppointmentData?.location_id === ''
													? ''
													: updateAppointmentData?.AppointmentDate ==
														  'Invalid Date'
														? ''
														: 'none'
							}
						>
							<Alert variant="filled" severity="error">
								Please Fill all Information!
							</Alert>
						</Box>
					}

					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						sx={{
							textAlign: 'center',
							fontWeight: '500',
							fontFamily: 'Poppins',
						}}
					>
						Update Appointment
					</Typography>
					<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
						<Grid container item xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
								<Grid
									item
									xs={12}
									lg={12}
									md={12}
									sm={12}
									xl={12}
									sx={{
										padding: ' 3px 13px',
									}}
								>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
										}}
									>
										Select Patient
									</Typography>
									<FormControl
										fullWidth
										sx={{
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									>
										<Select
											defaultValue=""
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '18%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											placeholder="Update Patient Name"
											value={udatePatientName}
											onChange={(e) => {
												setUpdatePatientName(e.target.value);
												setUpdateAppointmentData((prev) => ({
													...prev,
													patient_id: e.target.value,
												}));
											}}
										>
											{patientList.map((items, index) => {
												return (
													<MenuItem
														key={index}
														value={items?.patient_id}
														// style={{ width: '100%' }}
													>
														{items?.Name}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={11}
								lg={11}
								xl={11}
								sx={{
									padding: '8px 13px',
								}}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Reason
								</Typography>
								<TextField
									multiline
									fullWidth
									name="Reason"
									rows={3}
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
										boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
									}}
									value={updateReason}
									onChange={(e) => {
										setUpdateReason(e.target.value);
										setUpdateAppointmentData((prev) => ({
											...prev,
											Reason: e.target.value,
										}));
									}}
								/>
							</Grid>
						</Grid>

						<Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Update Provider Name
								</Typography>
								<FormControl
									fullWidth
									name="updateproviderId"
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
										boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
										'& .MuiOutlinedInput-input': {
											padding: '9px 0px 9px 6px',
										},
									}}
								>
									<Select
										defaultValue=""
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '18%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										placeholder="Update Provider Name"
										value={updateProvider}
										onChange={(e) => {
											setUpdateProvider(e.target.value);
											setUpdateAppointmentData((prev) => ({
												...prev,
												provider_id: e.target.value,
											}));
										}}
									>
										{providerList?.map((items, index) => {
											return (
												<MenuItem value={items?.id} key={index}>
													{items?.Fname + ' ' + items?.Lname}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Status
								</Typography>

								<FormControl fullWidth>
									<Select
										defaultValue=""
										labelId="Status"
										id="Status"
										value={updateAppointmentStatus}
										name="Status"
										onChange={(e) => {
											setUpdateAppointmentStatus(e.target.value);
											setUpdateAppointmentData((prev) => ({
												...prev,
												Status: e.target.value,
											}));
										}}
										sx={{
											height: '40px',
											width: '100%',
											borderRadius: '6px',
											border: '1px solid #00000026',
											boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											'& .MuiOutlinedInput-input': {
												padding: '9px 0px 9px 6px',
											},
										}}
									>
										<MenuItem value={'C'}>Completed</MenuItem>
										<MenuItem value={'D'}>Dismissed</MenuItem>
										<MenuItem value={'O'}>Other</MenuItem>
										<MenuItem selected value={'P'}>
											Pending
										</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Location
								</Typography>
								<FormControl fullWidth>
									<Select
										defaultValue=""
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '18%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										labelId="modallocation"
										id="modallocation"
										value={updateLocation}
										name="modallocation"
										sx={{ height: '45px', mt: 1 }}
										onChange={(e) => {
											setUpdateLocation(e.target.value);
											setUpdateAppointmentData((prev) => ({
												...prev,
												location_id: e.target.value,
											}));
										}}
									>
										{location?.map((items, index) => {
											return (
												<MenuItem value={items?.id} key={index}>
													{items?.Name}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Date Time
								</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DemoContainer
										components={['DateTimePicker']}
										sx={{ height: '100px' }}
									>
										<DemoItem>
											<DateTimePicker
												disablePast
												size="small"
												slotProps={{ textField: { size: 'small' } }}
												sx={{
													boxShadow: '1px 1px 10px #79ACF178 inset',
													width: '100%',
												}}
												value={selectedDate}
												onChange={(nValue) => {
													setselectedDate(nValue);
													setUpdateAppointmentData((prev) => ({
														...prev,
														AppointmentDate: dayjs(nValue).format(
															'YYYY-MM-DDTHH:mm:ss'
														),
													}));
												}}
											/>
										</DemoItem>
									</DemoContainer>
								</LocalizationProvider>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '5px',
							padding: '13px 8px 0px 8px',
						}}
						xs={12}
					>
						<Button
							onClick={() => {
								setOpen(false);
							}}
							sx={{
								mb: 1,
								background: '#ED2828',
								border: '2px solid #ED2828',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #ED2828',
									color: '#ED2828',
								},
							}}
						>
							Cancel
						</Button>

						<Button
							disabled={
								updateAppointmentData?.patient_id === ''
									? true
									: updateAppointmentData?.provider_id === ''
										? true
										: updateAppointmentData?.Status === ''
											? true
											: updateAppointmentData?.Reason === ''
												? true
												: updateAppointmentData?.location_id === ''
													? true
													: updateAppointmentData?.AppointmentDate ==
														  'Invalid Date'
														? true
														: false
							}
							sx={{
								mb: 1,
								background: '#FD7702',
								border: '2px solid #e87511',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #e87511',
									color: '#e87511',
								},
							}}
							onClick={() => {
								updateAppointmentInfo(appointmentID, updateAppointmentData);
							}}
						>
							Update Appointment
						</Button>
					</Grid>
				</Box>
			</Modal>
			{/* Delete Modal */}
			<Modal
				sx={{
					width: '60%',
					top: '20%',
					left: '25%',

					// transform: 'translate(-50%, -50%)',
				}}
				open={openDeleteModal.deleteModalOpen}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						bgcolor={'#0e4374'}
						height={'30px'}
						p={0}
						borderRadius={'5px 5px 0 0 '}
					>
						<Cancel
							sx={{ cursor: 'pointer', color: 'whitesmoke' }}
							onClick={() => {
								handleCloseDeleteModal();
							}}
						/>
					</Box>
					<Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
						<Typography
							id="modal-modal-title"
							variant="h6"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Are You Sure To Delete Appointment of{' '}
							<span style={{ color: '#2081B8' }}>
								{openDeleteModal?.deletingName}
							</span>
							?
						</Typography>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ mb: 1, bgcolor: '#ED2828', width: '100px', py: '5px' }}
								onClick={handleCloseDeleteModal}
							>
								No
							</Button>
							<Button
								variant="contained"
								sx={{ mb: 1, bgcolor: '#FD7702', width: '100px', py: '5px' }}
								onClick={() => {
									updateAppointmentInfo(openDeleteModal?.deletingId, {
										Deleted: true,
									});
								}}
							>
								Yes
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>

			{/* SnackBar */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={1800}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbar}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error!' : 'Appointment Updated Successfully!'}
				</Alert>
			</Snackbar>
		</Fragment>
	);
}

export default Schedular;
